module.exports = __webpack_public_path__ + "img/66.76a8551c.jpg";